import {
	SourcingRequestStatus,
	SourcingRequestType,
} from '@supply-mover-2-0/shared';

export const SOURCING_REQUEST_STATUS_OPTIONS = [
	{ value: SourcingRequestStatus.DRAFT, label: 'Draft' },
	{ value: SourcingRequestStatus.OPEN, label: 'Open' },
	{ value: SourcingRequestStatus.IN_PROGRESS, label: 'In Progress' },
	{
		value: SourcingRequestStatus.PARTIALLY_FULFILLED,
		label: 'Partially Fulfilled',
	},
	{ value: SourcingRequestStatus.FULFILLED, label: 'Fulfilled' },
	{ value: SourcingRequestStatus.CANCELLED, label: 'Cancelled' },
];

export const SOURCING_REQUEST_TYPE_OPTIONS = [
	{ value: SourcingRequestType.QUOTE, label: 'Quote' },
	{ value: SourcingRequestType.ORDER, label: 'Order' },
];

export const SOURCING_REQUEST_PRIORITY_OPTIONS = [
	{ value: 'low', label: 'Low' },
	{ value: 'normal', label: 'Normal' },
	{ value: 'high', label: 'High' },
	{ value: 'urgent', label: 'Urgent' },
];
